export default __webpack_public_path__ + "static/media/artboard.64b4a4f9.svg";